import AttachMoneyOutlinedIcon from '@mui/icons-material/AttachMoneyOutlined'
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn'
import AccessTimeOutlinedIcon from '@mui/icons-material/AccessTimeOutlined'
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined'

const WageMenu = {
    id: 'wagesRoot',
    title: 'WAGES',
    type: 'group',
    children: [
        {
            id: 'wages',
            title: 'Treatement Wages',
            type: 'item',
            url: '/wages',
            icon: AttachMoneyOutlinedIcon,
            breadcrumbs: false
        },
        {
            id: 'wageBoard',
            title: 'Wages',
            type: 'item',
            url: '/wageBoard',
            icon: AttachMoneyOutlinedIcon,
            breadcrumbs: false
        },
        // {
        //     id: 'timesheets',
        //     title: 'Timesheets',
        //     type: 'item',
        //     url: '/timesheets',
        //     icon: AccessTimeOutlinedIcon,
        //     breadcrumbs: false
        // },
        {
            id: 'timesheetBoard',
            title: 'Timesheets',
            type: 'item',
            url: '/timesheetBoard',
            icon: AccessTimeOutlinedIcon,
            breadcrumbs: false
        },
        // {
        //     id: 'commission',
        //     title: 'Commission',
        //     type: 'item',
        //     url: '/commission',
        //     icon: MonetizationOnOutlinedIcon,
        //     breadcrumbs: false
        // },
        {
            id: 'commissionBoard',
            title: 'Commission',
            type: 'item',
            url: '/commissionBoard',
            icon: MonetizationOnOutlinedIcon,
            breadcrumbs: false
        },
        {
            id: 'fixedWage',
            title: 'Fixed Wage',
            type: 'item',
            url: '/fixedWage',
            icon: MonetizationOnOutlinedIcon,
            breadcrumbs: false
        },
        {
            id: 'wageSummary',
            title: 'Wages Summary',
            type: 'item',
            url: '/wageSummaryHome',
            icon: MonetizationOnIcon,
            breadcrumbs: false
        },
        {
            id: 'wageSummaryBoard',
            title: 'Wage Summary',
            type: 'item',
            url: '/wageSummaryBoard',
            icon: MonetizationOnIcon,
            breadcrumbs: false
        }
    ]
}
export default WageMenu